import { LedgerReportOperationsEnum, } from "@adapters/presenters/action-interfaces/Reports/LedgerReport";
import LedgerSnapShotActions from "@frameworks/web/redux/actions/Reports/LedgerReport/LedgerSnapShot";
import LedgerDetailsActions from "@frameworks/web/redux/actions/Reports/LedgerReport/LedgerDetails";
import CommonOnePlatFormActions from "@frameworks/web/redux/actions/common/commonActions";
import LedgerSnapShotExtentionActions from "@frameworks/web/redux/actions/Reports/LedgerReport/LedgerSnapShotExtention";
import LedgerContractNoteActions from "@frameworks/web/redux/actions/Reports/LedgerReport/LedgerContractNote";
export default () => {
    return {
        snapShot: new LedgerSnapShotActions(),
        details: new LedgerDetailsActions(),
        [LedgerReportOperationsEnum.EMAILSTATUS]: new CommonOnePlatFormActions(),
        [LedgerReportOperationsEnum.DOWNLOADSTATUS]: new CommonOnePlatFormActions(),
        snapshotExtention: new LedgerSnapShotExtentionActions(),
        contractNote: new LedgerContractNoteActions(),
    };
};
